import { Button, Alert, Modal, Tooltip } from 'antd';
import Loader from 'src/components/loader.component';
import apiCalls from '../../api/apiCalls'
import { useState, useEffect } from 'react';
const CardOperationsDetails = ({ isModal, closeModal, data }) => {
    const [details, setDetails] = useState(null)
    const [errorMsg, setErrorMsg] = useState(null)
    const [loader, setLoader] = useState(false)
    useEffect(() => {
        if (data?.operatorId) { getDetails(data?.operatorId); }
    }, [data])
    const getDetails = async (id) => {
        try {
            setLoader(true)
            const response = await apiCalls.cardDetails('CardsOperations/Details', id)
            if (response.ok) {
                setDetails(response.data)
                setLoader(false)
            }
            else {
                setLoader(false)
                setErrorMsg(apiCalls.isErrorDispaly(response))
            }
        } catch (error) {
            setLoader(false)
            setErrorMsg(apiCalls.isErrorDispaly(response))
        }
    }
    return (
        <Modal
            open={isModal}
            onCancel={closeModal(false, null)}
            title={`Card Activity Details`}
            maskClosable={false}
            closeIcon={
                <Tooltip title="Close">
                    <span className="icon close c-pointer" />
                </Tooltip>
            }
            footer={""}>
            <div className=''>
                {loader && <div className='text-center'> <Loader /></div>}
                {errorMsg &&
                    <div className='mb-4'>
                        <Alert variant="danger" className='alert-flex' description={errorMsg}
                            showIcon closable>
                            <p style={{ color: 'red', margin: 10 }}><span className="icon error-alert me-2"></span>{errorMsg}</p>
                        </Alert>
                    </div>
                }
                {!loader && <>
                    <div className='grid xl:grid-cols-2 md:grid-cols-2 gap-6 rounded-5'>
                        <div className=''>
                            <p className='summary-label'>ID</p>
                            <p className='summary-value'>{details?.cardId || ""}</p>
                        </div>
                        <div className=''>
                            <p className='summary-label'>Card Number</p>
                            <p className='summary-value'>{details?.cardNumber || ""}</p>
                        </div>
                        <div className=''>
                            <p className='summary-label'>Card Name</p>
                            <p className='summary-value'>{details?.cardName || ""}</p>
                        </div>
                        <div className=''>
                            <p className='summary-label'>Card Type</p>
                            <p className='summary-value'>{details?.cardType || ""}</p>
                        </div>
                        <div className=''>
                            <p className='summary-label'>Email</p>
                            <p className='summary-value'>{details?.email || ""}</p>
                        </div>
                        <div className=''>
                            <p className='summary-label'>Operation Type</p>
                            <p className='summary-value'>{details?.operateType || ""}</p>
                        </div>
                        <div className=''>
                            <p className='summary-label'>Country</p>
                            <p className='summary-value'>{details?.country || ""}</p>
                        </div>
                        <div className=''>
                            <p className='summary-label'>State</p>
                            <p className='summary-value'>{details?.state || ""}</p>
                        </div>
                        <div className=''>
                            <p className='summary-label'>City</p>
                            <p className='summary-value'>{details?.city || ""}</p>
                        </div>
                        <div className=''>
                            <p className='summary-label'>Address</p>
                            <p className='summary-value'>{details?.address || ""}</p>
                        </div>
                        <div className=''>
                            <p className='summary-label'>Zip Code</p>
                            <p className='summary-value'>{details?.zipCode || ""}</p>
                        </div>
                        <div className=''>
                            <p className='summary-label'>Mobile</p>
                            <p className='summary-value'>{details?.phoneNo || ""}</p>
                        </div>
                    </div>
                    <div className='mt-4 text-right mb-6'><Button className='primary-btn' onClick={closeModal(false, null)}>Close</Button></div></>}
            </div>
        </Modal>
    )
}
export default CardOperationsDetails;